import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import Close from '@mui/icons-material/Close'
import Description from '@mui/icons-material/Description'
import { useBodyScrollLock } from 'src/hooks/useBodyScrollLock'
import { styled } from '@mui/material/styles'
import BookedEventLogsListing from '../slotItem/component/BookedEventLogsListing'

const DrawerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(250, 250, 255, 0.98) 100%);
  backdrop-filter: blur(20px);
`

const DrawerHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(67, 56, 202, 0.1);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 8px;
  }
`

const DrawerTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  color: rgba(67, 56, 202, 0.9);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;
`

const DrawerContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 0;
  
  @media (max-width: 768px) {
    padding: 0;
  }
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(67, 56, 202, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(67, 56, 202, 0.2);
    border-radius: 4px;
    
    &:hover {
      background: rgba(67, 56, 202, 0.3);
    }
  }
`

export default function BookedEventLogsDrawer({
  open,
  onClose,
  bookedSlot,
  apiEndpoint = '/api/secure/cc/support/events/logs/get',
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  
  // Lock body scroll when drawer is open
  useBodyScrollLock(open, 1300)

  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : '800px',
          maxWidth: isMobile ? '100%' : '90vw',
          height: isMobile ? '90vh' : '100%',
          maxHeight: isMobile ? '90vh' : '100%',
          borderTopLeftRadius: isMobile ? '20px' : 0,
          borderTopRightRadius: isMobile ? '20px' : 0,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(250, 250, 255, 0.98) 100%)',
          backdropFilter: 'blur(20px)',
        },
      }}
      ModalProps={{
        disableScrollLock: true, // We handle scroll lock with useBodyScrollLock hook
      }}
    >
      <DrawerContainer>
        {/* Drag Handle for Mobile Bottom Sheet */}
        {isMobile && (
          <Box
            sx={{
              width: '40px',
              height: '4px',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '2px',
              margin: '8px auto',
              cursor: 'grab',
              '&:active': {
                cursor: 'grabbing',
              },
            }}
          />
        )}
        <DrawerHeader>
          <DrawerTitle>
            <Description sx={{ fontSize: 20 }} />
            Join/Leave Logs
          </DrawerTitle>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'rgba(67, 56, 202, 0.7)',
              padding: isMobile ? '12px' : '8px',
              minWidth: isMobile ? '48px' : '40px',
              minHeight: isMobile ? '48px' : '40px',
              '&:hover': {
                background: 'rgba(67, 56, 202, 0.1)',
              },
            }}
          >
            <Close />
          </IconButton>
        </DrawerHeader>

        <DrawerContent>
          <BookedEventLogsListing
            bookedEventInfo={bookedSlot}
            closeDialog={onClose}
            apiEndpoint={apiEndpoint}
          />
        </DrawerContent>
      </DrawerContainer>
    </Drawer>
  )
}




